import Fetch, { serializeQueryString, V1 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';

const DEFAULT_GET_RESPONSE = {
  err_code: '500',
  err_message: '',
  result: null,
};

const DEFAULT_POST_RESPONSE = {
  err_code: '500',
  err_message: '',
  result: null,
};

export const getMTEligibilityStatus = () => {
  const resourceUrl = `${V1}stock/mt/kyc/eligibility/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getMarginOnboarding = (id) => {
  const resourceUrl = `${V1}margin/onboard/${id > 0 ? `${id}/` : ''}`;
  return Fetch.get(resourceUrl)
    .then((resp) => {
      if (resp.ok) return resp.json;
      return [];
    })
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return [];
    });
};

export const getMarginTradableStock = () => {
  const resourceUrl = `${V1}stock/mt/kyc/margin-tradeable/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getStockMarginToRegular = () => {
  const resourceUrl = `${V1}stock/mt/transfer/list/margin-to-reg/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getStockRegularToMargin = () => {
  const resourceUrl = `${V1}stock/mt/transfer/list/reg-to-margin/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getAvailableMarginLimit = (param, path) => {
  const resourceUrl = `${V1}stock/mt/kyc/${path}-available-limit/`;
  return Fetch.post(resourceUrl, param)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const activationMarginTrading = (param) => {
  const resourceUrl = `${V1}stock/mt/kyc/create-account/`;
  return Fetch.post(resourceUrl, param)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getMarginStatus = () => {
  const resourceUrl = `${V1}stock/mt/kyc/status/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getMarginRatio = () => {
  const resourceUrl = `${V1}mt/marginratio/user/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getMarginCashInfo = () => {
  const resourceUrl = `${V1}stock/mt/cash/withdrawable/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const postTransferMarginToRegular = (payload) => {
  const resourceUrl = `${V1}stock/mt/cash/withdraw/`;
  return Fetch.post(resourceUrl, payload, false, false)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });
};

export const postTransferRegularToMargin = (payload) => {
  const resourceUrl = `${V1}stock/mt/cash/topup/`;
  return Fetch.post(resourceUrl, payload, false, false)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });
};

/*
 * @param {string} type => margin-to-reg | reg-to-margin
 * @param {Object} payload
 * @param {arrayOf(Object)} payload.collateral_stocks
 * @param {string} payload.collateral_stock.stock_code
 * @param {number} payload.collateral_stock.lot
 */
export const postTransferPortoMargin = (type, payload) => {
  const resourceUrl = `${V1}stock/mt/transfer/portfolio/${type}/`;
  return Fetch.post(resourceUrl, payload, false, false)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });
};

export const postMarginLimit = (payload) => {
  const resourceUrl = `${V1}stock/mt/kyc/request-margin-limit/`;
  return Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });
};

export const getTransferHistory = (payload) => {
  const qs = serializeQueryString(payload);
  const resourceUrl = `${V1}stock/mt/transfer/history/${qs}`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getMarginStockAvailable = (code) => {
  const resourceUrl = `${V1}stock/detail/${code}/margin-tradeable/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};
